import React from 'react';

function ConnectingAgent({to,connected,message}) {
    return(
        <div className={`connecting-agent ${to== "bot" && "connecting-to-bot-disappear"}`}>
            {
                to== "agent" ?
                    <>
                        <i className="bot icon-headset-1"></i>
                        <p >{message}</p>
                    </>
                :
                to== "bot"?
                    <>
                        <i className="bot icon-bot"></i>
                        <p>{message}</p>
                    </>
                :
                connected =="agent"?
                    <div className="successfully-connected-wrapper">
                        <div className="content">Connected to John</div>
                    </div>
                :
                connected =="bot"?
                    <div className="connected-to"><span>Connected to MoRobot</span></div>  
                :
                null
            }          
        </div>
    )
}
export default ConnectingAgent;
